import { PHASE_DURATIONS } from './constants.js';
/** Réglages par défaut d'un salon (valeurs cohérentes prêtes à jouer). */
export function defaultSettings() {
    return {
        camouflageSec: PHASE_DURATIONS.camouflage,
        camouflageTimed: true,
        seekingSec: PHASE_DURATIONS.seeking,
        seekingTimed: true,
        boardSize: 820,
        progressiveZoom: true,
        zoomStepSec: 20,
        maxZoom: 4,
        hintsEnabled: true,
    };
}
/** Critères de tri du classement global (#24). */
export const LEADERBOARD_SORTS = ['xp', 'wins', 'found', 'camo'];
//# sourceMappingURL=types.js.map